export interface HonoraryMembership {
  ehrenmitglied_ab?: string | null;
  ehrenmitglied_bis?: string | null;
}
export const datePart = (value?: string | null) => value ? value.slice(0, 10) : '';
export function honoraryInYear(member: HonoraryMembership, year: number): boolean {
  const from = datePart(member.ehrenmitglied_ab), until = datePart(member.ehrenmitglied_bis);
  const januaryFirst = `${year}-01-01`;
  return !!from && from <= januaryFirst && (!until || until >= januaryFirst);
}
export function honoraryOnDate(member: HonoraryMembership, day = new Date().toLocaleDateString('sv-SE')): boolean {
  const from = datePart(member.ehrenmitglied_ab), until = datePart(member.ehrenmitglied_bis);
  return !!from && from <= day && (!until || until >= day);
}
export function honoraryPeriod(member: HonoraryMembership): string {
  const format = (value: string) => value.split('-').reverse().join('.');
  const from = datePart(member.ehrenmitglied_ab), until = datePart(member.ehrenmitglied_bis);
  return from ? `Ab ${format(from)}${until ? ` bis ${format(until)}` : ' · unbefristet'}` : 'Keine Ehrenmitgliedschaft';
}
